import { ModelBase, Property, Required, ShortString } from '@skylab-shared/core';

export class ExpenseModel extends ModelBase {
    @Property({ identifiable: true })
    public id: number;

    @Property()
    @ShortString('data-model.expense.validation.name.length')
    @Required('data-model.expense.validation.name.non-empty')
    public name: string;
}
